import React from "react";
import {getHomeUrl} from "../../backend/internalUrls";
import { BreadcrumbGroup, BreadcrumbGroupProps } from "@amzn/awsui-components-react";

const home: BreadcrumbGroupProps.Item = {text: "APA", href: getHomeUrl()};

export function Breadcrumbs(props: { items: BreadcrumbGroupProps.Item[] }) {
    const itemsWithDefaults = [home];
    props.items.forEach(item => itemsWithDefaults.push(item));
    return (
        <BreadcrumbGroup
            items={itemsWithDefaults}
            ariaLabel="Breadcrumbs"
        />
    );
}
